<dx-toolbar height="54" style="padding-left: 16px; padding-right: 16px;" *ngIf="!isPhoneOrTablet">
    <dxi-item location="after">
        <dx-button
            text="Acknowledge"
            [disabled]="ButtonsDisabled || acknowledgeOrderSelected || pendingOrderSelected"
            (click)="ack()"
        ></dx-button>
    </dxi-item>
    <dxi-item location="after">
        <dx-button text="Email Results" [disabled]="selectedItemsIds.length === 0 || fusionAuthService.Profile === undefined" (onClick)="openEmailFax('email')"></dx-button>
    </dxi-item>
    <dxi-item location="after">
        <dx-button text="Fax Results" [disabled]="selectedItemsIds.length === 0 || fusionAuthService.Profile === undefined" (onClick)="openEmailFax('fax')"></dx-button>
    </dxi-item>
    <dxi-item location="after">
        <dx-button text="Update Bill To" [disabled]="selectedItemsIds.length === 0" (onClick)="openUpdateBillTo()"></dx-button>
    </dxi-item>
  <dxi-item location="after">
    <dx-button
      text="Sign Orders"
      [disabled]="ButtonsDisabled || signedOrderSelected"
      (click)="signOrders()"
    ></dx-button>
  </dxi-item>
    <dxi-item location="after">
        <dx-button
            [disabled]="selectedItemsIds.length === 0"
            text="Print Results"
            (click)="printLabResults()"
        ></dx-button>
    </dxi-item>
    <dxi-item location="after">
        <dx-button
            [disabled]="selectedItemsIds.length === 0"
            text="Print Order Log"
            (click)="printOrderLog()"
        ></dx-button>
    </dxi-item>
  <dxi-item location="after">
    <dx-button
      [disabled]="selectedItemsIds.length === 0"
      text="Print Order Details"
      (click)="printOrderDetails()"
    ></dx-button>
  </dxi-item>
    <dxi-item location="after">
        <dx-button
            icon="columnchooser"
            (click)="showColumnChooser()"
        ></dx-button>
    </dxi-item>
</dx-toolbar>
<dx-data-grid
    [dataSource]="dataSource.value"
    [showRowLines]="true"
    [showBorders]="true"
    [highlightChanges]="true"
    [allowColumnReordering]="true"
    [repaintChangesOnly]="true"
    [hoverStateEnabled]="true"
    height="60vh"
    style="min-width: 250px !important;"
    [allowColumnResizing]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    (selectedRowKeysChange)="itemsSelected($event)"
    (onRowClick)="rowClick($event)"
    (onContentReady)="onContentReady()"
    [columnHidingEnabled]="isPhoneOrTablet">
    <dxo-scrolling mode="multiple"></dxo-scrolling>
    <dxo-pager
        [visible]="true"
        [allowedPageSizes]="[10, 20, 50, 100]"
        [showInfo]="true"
        [showNavigationButtons]="true"
        [showPageSizeSelector]="true"
    ></dxo-pager>
    <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-selection mode="multiple" showCheckBoxesMode="always" selectAllMode="page"></dxo-selection>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true"></dxo-remote-operations>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxi-column dataField="id" [visible]="false" [showInColumnChooser]="false" [showEditorAlways]="false"
                [showWhenGrouped]="false" [allowFiltering]="false" sortIndex="1" sortOrder="desc"></dxi-column>
    <dxi-column caption="Order Number" cellTemplate="selectTemplate" [hidingPriority]="isPhoneOrTablet ? 11 : null" [minWidth]="80"></dxi-column>
    <dxi-column caption="Order Date" dataField="orderDate" dataType="date" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 7 : null"></dxi-column>
    <dxi-column caption="Collection Date" dataField="orderCollectionDate" dataType="date" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 5 : null"></dxi-column>
    <dxi-column cssClass="wrappedColumnClass" caption="Last name" dataField="patientLastName" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 10 : null" [minWidth]="60"></dxi-column>
    <dxi-column cssClass="wrappedColumnClass" caption="First name" dataField="patientFirstName" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 9 : null" [minWidth]="60"></dxi-column>
    <dxi-column caption="Birthdate" dataField="patientDoB" dataType="date" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 4 : null"></dxi-column>
    <dxi-column caption="Client" dataField="client" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 8 : null"></dxi-column>
    <dxi-column caption="Unit" dataField="unit" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 3 : null" [showInColumnChooser]="true" [visible]="false"></dxi-column>
    <dxi-column caption="Room" cellTemplate="roomCellTemplate" [hidingPriority]="isPhoneOrTablet ? 2 : null" [showInColumnChooser]="true" [visible]="false"></dxi-column>
  <dxi-column caption="Signed" cellTemplate="signatureCellTemplate" cssClass="align-vertical-cell" alignment="center" [visible]="false" [showInColumnChooser]="true" [hidingPriority]="1"></dxi-column>
    <dxi-column caption="Tests" dataField="testNames" [hidingPriority]="isPhoneOrTablet ? 0 : null"></dxi-column>
    <dxi-column [visible]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 1"
                *ngIf="webResultSettings !== undefined && webResultSettings.length >= 1"
                headerCellTemplate="firstTestHeaderTemplate" caption="First Test" cellTemplate="firstTestTemplate"
                [showInColumnChooser]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 1"></dxi-column>
    <dxi-column [visible]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 2"
                *ngIf="webResultSettings !== undefined && webResultSettings.length >= 2"
                headerCellTemplate="secondTestHeaderTemplate" caption="Second Test" cellTemplate="secondTestTemplate"
                [showInColumnChooser]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 2"></dxi-column>
    <dxi-column [visible]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 3"
                *ngIf="webResultSettings !== undefined && webResultSettings.length >= 3"
                headerCellTemplate="thirdTestHeaderTemplate" caption="Third Test" cellTemplate="thirdTestTemplate"
                [showInColumnChooser]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 3"></dxi-column>
    <dxi-column [visible]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 4"
                *ngIf="webResultSettings !== undefined && webResultSettings.length >= 4"
                headerCellTemplate="fourthTestHeaderTemplate" caption="Fourth Test" cellTemplate="fourthTestTemplate"
                [showInColumnChooser]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 4"></dxi-column>
    <dxi-column [visible]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length === 5"
                *ngIf="webResultSettings !== undefined && webResultSettings.length >= 5"
                headerCellTemplate="fifthTestHeaderTemplate" caption="Fifth Test" cellTemplate="fifthTestTemplate"
                [showInColumnChooser]="!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length === 5"></dxi-column>
    <dxi-column caption="Ack" dataField="onlineAckUser" cellTemplate="ackTemplate" cssClass="align-vertical-cell" alignment="center"
                [allowFiltering]="false" [allowHeaderFiltering]="true" [hidingPriority]="isPhoneOrTablet ? 1 : null" width="70">
        <dxo-header-filter [dataSource]="ackHeaderFilter" [allowSearch]="false"></dxo-header-filter>
    </dxi-column>
    <dxi-column caption="Status" cellTemplate="statusCellTemplate" cssClass="align-vertical-cell" allowReordering="false" [allowHeaderFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 6 : null"></dxi-column>
    <dxi-column cellTemplate="editTemplate" cssClass="align-vertical-cell" [allowReordering]="false" alignment="center" [width]="'30px'"
                [hidingPriority]="isPhoneOrTablet ? 11 : null" [showInColumnChooser]="false" [visible]="isPhoneOrTablet"></dxi-column>

    <div *dxTemplate="let order of 'selectTemplate'">
        {{order.data.codeValue}}<br>
        <a *ngIf="order.data.hasMissingInfo && showMissingInfo" (click)="openMissingInfo(order)" class="tooltip" style="cursor: pointer">missing information</a>
    </div>

  <div *dxTemplate="let order of 'signatureCellTemplate'">
    <div *ngIf="order.data.hasSignature" fxLayout="row" fxLayoutAlign="center">
      <dx-tooltip
        target="#signature-{{ order.data.id }}"
        showEvent="dxhoverstart"
        hideEvent="dxhoverend"
      >
        <div *dxTemplate="let data of 'content'">
          <app-signature-viewer
            [orderId]="order.data.id"
          ></app-signature-viewer>
        </div>
      </dx-tooltip>
      <div id="signature-{{ order.data.id }}" class="dx-icon-todo"></div>
    </div>
  </div>

    <div *dxTemplate="let order of 'ackTemplate'">
        <dx-tooltip target="#icon-{{ order.data.id }}" showEvent="dxhoverstart" hideEvent="dxhoverend">
            <div *dxTemplate="let data of 'content'">
                <p><strong>User: </strong>{{ order.data.onlineAckUser }}</p>
                <p><strong>Date: </strong>{{ formatDate(order.data.onlineAckDateTime) }}</p>
            </div>
        </dx-tooltip>
        <i *ngIf="order.data.onlineAckUser" id="icon-{{ order.data.id }}" class="dx-icon-check"></i>
    </div>

    <div *dxTemplate="let order of 'roomCellTemplate'">
        {{ getPatientRoomBed(order.data) }}
    </div>


    <div *dxTemplate="let title of 'firstTestHeaderTemplate'">
        {{ webResultSettings[0].testName }}
    </div>

    <div *dxTemplate="let order of 'firstTestTemplate'">
        {{ testResult(webResultSettings[0].testId, order.data)}}
    </div>

    <div *dxTemplate="let title of 'secondTestHeaderTemplate'">
        {{ webResultSettings[1].testName }}
    </div>

    <div *dxTemplate="let order of 'secondTestTemplate'">
        {{ testResult(webResultSettings[1].testId, order.data)}}
    </div>

    <div *dxTemplate="let title of 'thirdTestHeaderTemplate'">
        {{ webResultSettings[2].testName }}
    </div>

    <div *dxTemplate="let order of 'thirdTestTemplate'">
        {{ testResult(webResultSettings[2].testId, order.data)}}
    </div>

    <div *dxTemplate="let title of 'fourthTestHeaderTemplate'">
        {{ webResultSettings[3].testName }}
    </div>

    <div *dxTemplate="let order of 'fourthTestTemplate'">
        {{ testResult(webResultSettings[3].testId, order.data)}}
    </div>

    <div *dxTemplate="let title of 'fifthTestHeaderTemplate'">
        {{ webResultSettings[4].testName }}
    </div>

    <div *dxTemplate="let order of 'fifthTestTemplate'">
        {{ testResult(webResultSettings[4].testId, order.data) }}
    </div>

    <div *dxTemplate="let order of 'statusCellTemplate'">
        <div fxLayout="row" fxLayoutAlign="center center" [innerHTML]="getStatus(order.data)"></div>
        <app-ai-result-indicator *ngIf="isInterpretationEnabled" [orderCode]="order.data.codeValue" ></app-ai-result-indicator>
    </div>

    <div *dxTemplate="let order of 'editTemplate'">
        <div fxLayout="row" fxLayoutAlign="center center" style="cursor: pointer;">
            <i class="fa fa-eye" title="Edit" (click)="sendToPreview(order.data.id)"></i>
        </div>
    </div>
</dx-data-grid>
<dx-speed-dial-action
    *ngIf="FABDisabled"
    icon="message"
    label="Email Results"
    [index]="1"
    (onClick)="openEmailFax('email')">
</dx-speed-dial-action>
<dx-speed-dial-action
    *ngIf="FABDisabled"
    icon="message"
    label="Fax Results"
    [index]="2"
    (onClick)="openEmailFax('fax')">
</dx-speed-dial-action>
<dx-speed-dial-action
    *ngIf="FABDisabled"
    icon="print"
    label="Print Results"
    [index]="3"
    (onClick)="printLabResults()">
</dx-speed-dial-action>
<dx-speed-dial-action
    *ngIf="FABDisabled"
    icon="export"
    label="Print Order Log"
    [index]="4"
    (onClick)="printOrderLog()">
</dx-speed-dial-action>
<dx-speed-dial-action
  *ngIf="FABDisabled"
  icon="export"
  label="Print Order Details"
  [index]="4"
  (onClick)="printOrderDetails()">
</dx-speed-dial-action>
<dx-speed-dial-action
    *ngIf="FABDisabled"
    icon="check"
    label="Acknowledge"
    [index]="5"
    (onClick)="ack()">
</dx-speed-dial-action>
<dx-speed-dial-action
  *ngIf="FABDisabled"
  icon="background"
  label="Sign Orders"
  [index]="6"
  (onClick)="signOrders()">
</dx-speed-dial-action>

<app-signature-dialog
  [popupVisible]="signDialogVisible"
  (closeEvent)="signDialogClosed($event)"
></app-signature-dialog>

<app-missing-info
    [popupVisible]="missingInfoPopupVisible"
    [order]="missingInfoData"
    (closeEvent)="closeMissingInfo($event)"
></app-missing-info>

<app-email-fax-dialog
    [popupVisible]="emailFaxVisible"
    [type]="type"
    [ids]="selectedItemsIds"
    [from]="'order'"
    (closeEvent)="emailFaxVisible = false">
</app-email-fax-dialog>

<app-update-bill-to
    [popupVisible]="updateBillToVisible"
    [ids]="selectedItemsIds"
    [from]="'order'"
    (closeEvent)="closeUpdateBillTo()">
</app-update-bill-to>

<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
